<template>
  <v-container grid-list-sm>
    <ProjectResponseHeader />
    <br />
    <ProjectResponseMenuTab :active="3" />
    <br />
    <v-layout>
      <v-flex sm12>
        <ProjectSettingsPreview />
      </v-flex>
    </v-layout>
  </v-container>
</template>
<script>
  import ProjectResponseHeader from "../../components/project/ProjectResponseHeader";
  import ProjectResponseMenuTab from "../../components/project/ProjectResponseMenuTab";
  import ProjectSettingsPreview from "../../components/project/ProjectSettingsPreview";
  export default {
    data() {
      return {
        statusCount: null,
      };
    },
    components: {
      ProjectResponseHeader,
      ProjectResponseMenuTab,
      ProjectSettingsPreview,
    },
    computed: {
      // ...mapState(["auth"]),
    },
    created() {
      // this.fetchStatusCount();
    },
    methods: {
      // async fetchStatusCount() {
      //   const { data } = await api.fetchData(
      //     this.auth.token,
      //     `task-status-count/${this.$route.params.id}`
      //   );
      //   this.statusCount = data.data;
      // },
    },
  };
</script>
